module.exports = __webpack_public_path__ + "static/media/rating-hub-preview.172547ae.jpg";